export default __webpack_public_path__ + "static/media/bellIconHCSelected.a04bc5ff.svg";